<template>
  <form :id="'frm-'+id"
        class="px-3"
        method="post"
        onsubmit="return false">
    <div :id="id"
         :aria-labelledby="id+'-title'"
         :data-backdrop="'static'"
         :data-keyboard="'false'"
         aria-hidden="true"
         class="modal fade"
         role="dialog"
         tabindex="-1">
      
      <div class="modal-dialog modal-dialog-scrollable" role="document">
        <div class="modal-content">
          <div class="modal-header mb-2">
            <h5 :id="id+'-title'" class="modal-title">{{ title }}</h5>
          </div>
          <div class="modal-body">
            <div class="container">
              <div class="form-group mb-4">
                <label for="budget">Financiadora: *</label>
                <select id="funder"
                        name="funder"
                        class="form-control search-modal-funders select2-input"></select>
              </div>
              
              <div class="form-group mb-4">
                <label for="budget">Presupuesto (M.N.): *</label>
                <input type="number"
                       name="budget"
                       id="budget"
                       placeholder="$0.00"
                       v-model="funder.pivot.budget"
                       class="form-control">
              </div>
              
              <div class="form-group">
                <div class="custom-file">
                  <input type="file"
                         class="custom-file-input"
                         id="file"
                         @change="filesSelected"
                         accept="application/pdf"
                         ref="files">
                  <label class="custom-file-label" for="file">
                    Seleccione el nuevo convenio</label>
                </div>
              </div>
            </div>
          </div>
          
          <div class="modal-footer flex px-2 shadow-none modal-body-scrolled">
            <button :disabled="saving"
                    class="btn btn-primary mr-2"
                    type="button"
                    @click="updateFunder">
              <template v-if="!saving">Actualizar</template>
              <span v-if="saving"
                    class="spinner-border text-yellow-500 spinner-border-sm"
                    role="status">
                <span class="sr-only">Agregando...</span>
              </span>
            </button>
            
            <button class="btn btn-secondary"
                    data-dismiss="modal"
                    type="button"
                    :disabled="saving">Cancelar
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
  import { mapActions } from 'vuex'
  import { AlertManager } from '../utils/AlertManager'
  
  export default {
    name: 'EditFunderModal',
    props: {
      title: {
        default: 'Registro de compromiso',
      },
      id: {
        default: 'financing-commitments-modal',
      },
      funder: Object,
      amendment: {
        type: Object,
        default: null,
      },
    },
    data () {
      return {
        newFunder: null,
        saving: false,
        file: null,
      }
    },
    methods: {
      ...mapActions({
        updateFunderInfo: 'protocols/updateFunderInformation',
        updateAmendmentFunderInfo: 'amendments/updateFunderInformation',
      }),
      
      filesSelected (e) {
        const file = e.target.files.length ? e.target.files[0] : null

        if (file) {
          if(file.type.indexOf('pdf') === -1) {
            AlertManager.error(`El formato del archivo ${file.name} no es aceptado. Seleccione un archivo PDF`, {
              timeout: 10000,
            })

            $(this.$refs.files).val('')
            
            return
          }
          
          if (!this.checkFileSize(file)) {
            AlertManager.error('El tamaño máximo de archivo es de 2MB')
            
            $(this.$refs.files).val('')

            return
          }
          
          if(!this.checkFileType(file)) {
            AlertManager.error('Seleccione un archivo PDF.')
            
            $(this.$refs.files).val('')

            return
          }

          this.file = file
        }
      },
      async updateFunder () {
        this.saving = true
        
        const formData = new FormData()
        
        formData.append('files[]', this.file)
        formData.append('budget', this.funder.pivot.budget)
        formData.append('funder', this.funder.pivot.funder_id)
        formData.append('protocol', this.funder.pivot.protocol_id)
        
        if (this.newFunder && this.newFunder !== this.funder.pivot.funder_id) {
          formData.append('new_funder', this.newFunder)
        }

        if (this.amendment) {
          formData.append('amendment_id', this.amendment.id)
          formData.append('amendment_type', this.amendment.type.key)
        }

        if (this.funder.pivot.hasOwnProperty('amendment_id')) {
          formData.append('amendment_id', this.funder.pivot.amendment_id)
          formData.append('amendment_type', this.funder.pivot.amendment_type_key)
        }
        
        let response
        
        if (!this.amendment && !this.funder.pivot.hasOwnProperty('amendment_id')) {
          response = await this.updateFunderInfo(formData)
        }
        else {
          response = await this.updateAmendmentFunderInfo(formData)
        }
        
        AlertManager.success(response.message)
        
        this.$emit('funder-updated')
  
        this.saving = false
      },
      checkFileSize(file) {
        let maxFileSize = 4 * 1024 * 1024 // 2MB
        
        const fileSize  = file.size
        
        return fileSize <= maxFileSize;
      },
      checkFileType(file) {
        const extension = file.name.slice((Math.max(0, file.name.lastIndexOf('.')) || Infinity) + 1)
        
        return !(extension && extension.toLowerCase() !== 'pdf');
      },
    },
    computed: {},
    mounted () {
      const vm = this

      /**
       * select2 - Search funders
       */
      vm.$search = $('.search-modal-funders')
      vm.$search.select2({
        ajax: {
          url: '/api/v1/funders',
          dataType: 'json',
          placeholder: 'Seleccione la financiadora',
          language: 'es',
          headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
          },
          data (params) {
            return {
              q: params.term,
              page: params.page || 1,
            }
          },
          processResults (data, params) {
            params.page = params.page || 1

            return {
              results: data.data,
              pagination: {
                more: (params.page * 10) < data.meta.total,
              },
            }
          },
        },
      })

      vm.$search.on('select2:select', function (e) {
        vm.newFunder = e.params.data.id
      })

      addDefaultFunder()

      $(`#${vm.id}`).on('show.bs.modal', function(){
        addDefaultFunder()
      });

      $(`#${vm.id}`).on('hide.bs.modal', function(){
        vm.newFunder = null
      });

      function addDefaultFunder() {
        const funder = {
            id: vm.funder.id,
            text: vm.funder.title,
        };

        if (vm.$search.find("option[value='" + funder.id + "']").length) {
          vm.$search.val(funder.id).trigger('change');
        }else {
          const newOption = new Option(funder.text, funder.id, true, true);
          vm.$search.append(newOption).trigger('change');
        }
      }
    }
  }
</script>
